import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Endpoints } from "@/config/endpoints";
import { all_routes } from "@/feature-module/router/all-routes";
import TestimonialGrid from "./testimonial-grid";
import useTestimonialViewModel from "@/feature-module/testimonial/presentation/hooks/use-testimonial-view-model";

const Footer = () => {
  const routes = all_routes;

  const { getAllTestimonials, isGetTestimonialLoading } = useTestimonialViewModel();
  const API_BASE = Endpoints.backendApi;

  const buildImageUrl = (path: string) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${API_BASE}${path}`;
  };

  const featuredTestimonials = getAllTestimonials
    .slice(0, 3)
    .map((testimonial: any) => ({
      id: testimonial.id,
      title: testimonial.review_title,
      content: testimonial.review_text,
      imagePath: buildImageUrl(testimonial.testimonial_image?.path || ""),
      name: testimonial.reviewer_name,
      category: testimonial.reviewer_designation,
      altText: testimonial.reviewer_name,
    }));

  useEffect(() => {
    try {
      AOS.init({ duration: 1000, once: true });
    } catch (e) {
      console.error("AOS initialization failed:", e);
    }
  }, []);
  return (
    <footer className="footer">
      <div className="container">
        {/* Testimonials in Footer */}
        <div className="footer-join aos" data-aos="fade-up">
          <div className="container">
            {isGetTestimonialLoading ? (
              <div className="text-center py-3">
                <div className="spinner-border text-light" role="status">
                  <span className="visually-hidden">Loading testimonials...</span>
                </div>
              </div>
            ) : featuredTestimonials.length > 0 ? (
              <>
                <TestimonialGrid testimonials={featuredTestimonials} />
                <div className="text-center mt-3">
                  <Link to={routes.testimonials} className="btn btn-secondary" aria-label="View all testimonials">
                    View All Testimonials
                  </Link>
                </div>
              </>
            ) : (
              <div className="text-center py-3">
                <p className="text-light">No testimonials available at the moment.</p>
                <Link to={routes.testimonials} className="btn btn-secondary mt-3" aria-label="View testimonials">
                  View Testimonials
                </Link>
              </div>
            )}
          </div>
        </div>
        {/* /Testimonials in Footer */}
        {/* Footer Top */}
        <div className="footer-top">
          <div className="row">
            <div className="col-lg-2 col-md-6">
              {/* Footer Widget */}
              <div className="footer-widget footer-menu">
                <h4 className="footer-title">Contact us</h4>
                <div className="footer-address-blk">
                  
                  <div className="footer-call">
                    <a href="mailto:coach.sagheer@gmail.com">
                      coach.sagheer@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              {/* /Footer Widget */}
            </div>
            <div className="col-lg-2 col-md-6">
              {/* Footer Widget */}
              <div className="footer-widget footer-menu">
                <h4 className="footer-title">Quick Links</h4>
                <ul>
                  <li>
                    <Link to={routes.aboutUs}>About us</Link>
                  </li>
                  <li>
                    <Link to={routes.allServices}>Services</Link>
                  </li>
                  <li>
                    <Link to={routes.contactUs}>Contact us</Link>
                  </li>
                </ul>
              </div>
              {/* /Footer Widget */}
            </div>
            <div className="col-lg-2 col-md-6">
              {/* Footer Widget */}
              <div className="footer-widget footer-menu">
                <h4 className="footer-title">Support</h4>
                <ul>
                  <li>
                    <Link to={routes.contactUs}>Contact Us</Link>
                  </li>
                  <li>
                    <Link to={routes.privacyPolicy}>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to={routes.termsCondition}>
                      Terms &amp; Conditions
                    </Link>
                  </li>
                </ul>
              </div>
              {/* /Footer Widget */}
            </div>
          </div>
        </div>
        {/* /Footer Top */}
      </div>
      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          {/* Copyright */}
          <div className="copyright">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="copyright-text">
                  <p className="mb-0">
                    © {new Date().getFullYear()} Enorus LTD - All rights
                    reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* /Copyright */}
        </div>
      </div>
      {/* /Footer Bottom */}
    </footer>
  );
};

export default Footer;
